import {
  createReactRouterV6Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration,
} from '@grafana/faro-react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import App from './App';
import { AppProviders } from './AppProviders';
import config from '../config/default.json';
import getMainSiteLocation from './helpers/getMainSiteLocation';

const { gtmEnvironment, gtmAuth, gtmId, dataLayerName } = config;

const tagManagerArgs = {
  gtmId,
  dataLayerName,
  ...(gtmEnvironment && { preview: gtmEnvironment }),
  ...(gtmAuth && { auth: gtmAuth }),
};

const mainSiteLocation = getMainSiteLocation(config, window.location.origin);

const appName = 'web-app-checkout';

initializeFaro({
  url: config.grafanaFaroApmUrl,
  app: {
    name: appName,
    environment: mainSiteLocation?.env ?? 'dev',
  },
  sessionTracking: {
    samplingRate: 0.1,
    persistent: true,
  },
  instrumentations: [
    ...getWebInstrumentations(),

    new ReactIntegration({
      router: createReactRouterV6Options({
        createRoutesFromChildren,
        matchRoutes,
        Routes,
        useLocation,
        useNavigationType,
      }),
    }),
  ],
});

TagManager.initialize(tagManagerArgs);

const container = document.getElementById('checkout');
const root = createRoot(container);
root.render(
  <AppProviders>
    <App />
  </AppProviders>,
);
